module.exports = __webpack_public_path__ + "img/永祥股份.e3a5c85f.png";